import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, ClipboardListIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { offer } from '../data/offer';
import { formatARS } from '../utils/currency';
const proofPoints = [{
  icon: ClipboardListIcon,
  text: '30 clases listas para dar'
}, {
  icon: ZapIcon,
  text: 'Fuerza excéntrica, no volumen'
}, {
  icon: ShieldCheckIcon,
  text: `${offer.guaranteeDays} días de garantía total`
}];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-ink" data-id="element-59" data-mp="xbfkxbqnjh66">
      <img src="https://cdn.magicpatterns.com/patterns/generated-images/6977cb3e-d2e9-414b-bea1-addafaf523c5.jpg" alt="Corredor de trail ascendiendo una cresta rocosa al amanecer" className="absolute inset-0 h-full w-full object-cover object-right opacity-45" data-id="element-60" data-mp="sbb1pdyd08c9" />
      <div className="absolute inset-0 bg-ink/70" aria-hidden="true" data-id="element-61" data-mp="3cz5x6h3fwa2z" />
      <div className="relative mx-auto max-w-6xl px-4 pb-16 pt-16 sm:pb-24 sm:pt-24" data-id="element-62" data-mp="3814aznapvuna">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="max-w-3xl" data-id="element-63" data-mp="3j9ty8ric7ai4">
          <h1 className="font-display font-extrabold uppercase leading-[0.9] tracking-tight text-bone" data-id="element-64" data-mp="39a36gxl5v9lq">
            <span className="block text-[3.5rem] sm:text-7xl lg:text-8xl" data-id="element-65" data-mp="3e7l8s54oaqkr">Profe de trail</span>
            <span className="mt-3 block text-3xl leading-[1.05] text-lime sm:text-5xl" data-id="element-66" data-mp="30gq65akrp5pm">
              Cambiá tu forma de enseñar con este pack
            </span>
          </h1>

          <p className="mt-8 max-w-2xl text-lg leading-relaxed text-mute sm:text-xl" data-id="element-67" data-mp="2ql69un2ak50c">
            El sistema de entrenamiento <strong className="font-semibold text-bone" data-id="element-68" data-mp="2vjg9payyntsa">«antifrágil»</strong> para profes que quieren dar clases con criterio, hacer progresar a sus alumnos en la montaña y que lleguen a la meta con una sonrisa (y no en la carpa médica).
          </p>

          <div className="mt-10 flex flex-col items-start gap-4 sm:flex-row sm:items-center" data-id="element-69" data-mp="s2jmbumnjwig">
            <CtaButton data-id="element-70" data-mp="nbl3anaa4kbi">Quiero el pack por {formatARS(offer.price)}</CtaButton>
            <p className="text-sm text-mute" data-id="element-71" data-mp="n9i3jbjbrctl">
              <span className="line-through" data-id="element-72" data-mp="id9t2bg2o7sr">{formatARS(offer.totalValue)}</span>{' '}
              <span className="font-semibold text-bone" data-id="element-73" data-mp="ddww2xvhlkcg">{formatARS(offer.price)} pago único</span> · Acceso inmediato
            </p>
          </div>

          <ul className="mt-12 flex flex-wrap gap-x-8 gap-y-3" data-id="element-74" data-mp="1ayt9d7fj7xel">
            {proofPoints.map(({
            icon: Icon,
            text
          }) => <li key={text} className="flex items-center gap-2 text-sm text-bone/70" data-id="element-75" data-mp="112pud0zl04a8">
                <Icon aria-hidden="true" className="h-4 w-4 text-lime" data-id="element-76" data-mp="114kkctppmml6" />
                {text}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </header>;
}